export default function toCSSUnit(value: string | number, unit = 'px'): string {
    if (Number.isInteger(value)) {
        return `${value}${unit}`
    }

    return value as string
}
